module.exports = __webpack_public_path__ + "img/flags/CA.17ef24f.png";